export function initDrawer() {
  var hamburger = document.getElementById('mj-hamburger');
  var drawer = document.getElementById('mj-drawer');
  var drawerOverlay = document.getElementById('mj-drawer-overlay');
  var body = document.body;
  var scrollY = 0;
  var touchmoveOpt = { passive: false };

  function preventTouchMove(e) {
    e.preventDefault();
  }

  /**
   * @param {boolean} [skipScrollRestore] - true のとき scrollTo(0, scrollY) をスキップ（サービスアンカーへ続けてスクロールする場合）
   */
  function closeDrawer(skipScrollRestore) {
    if (!hamburger || !drawer) return;
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('is-active');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('drawer-open');
    document.documentElement.classList.remove('drawer-open');
    if (drawerOverlay) {
      drawerOverlay.removeEventListener('touchmove', preventTouchMove, touchmoveOpt);
    }
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.width = '';
    if (!skipScrollRestore) {
      window.scrollTo(0, scrollY);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        });
      });
    }
  }

  if (!hamburger || !drawer) return;

  hamburger.addEventListener('click', function () {
    var open = hamburger.getAttribute('aria-expanded') === 'true';
    if (open) {
      closeDrawer();
    } else {
      scrollY = window.scrollY;
      body.style.top = '-' + scrollY + 'px';
      body.style.position = 'fixed';
      body.style.left = '0';
      body.style.width = '100%';
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.classList.add('is-active');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open');
      document.documentElement.classList.add('drawer-open');
      if (drawerOverlay) {
        drawerOverlay.addEventListener('touchmove', preventTouchMove, touchmoveOpt);
      }
    }
  });
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }

  var SERVICE_ANCHOR_IDS = ['production', 'lecture', 'consulting'];
  function isServicePage() {
    var pathname = window.location.pathname || '';
    var base = pathname.replace(/\/$/, '');
    return base === '/service' || base.endsWith('/service');
  }
  /**
   * サービスアンカーへ「一瞬もトップを見せず」スクロールしてからドロワーを閉じる。
   * 手順: body を fixed のまま target が上に来るよう top をずらす → scrollTo で位置を記録 →
   * そのまま closeDrawer(true) で fixed を外す。これで描画が一度もトップに戻らない。
   */
  function closeDrawerAndScrollToAnchor(hashId) {
    var el = document.getElementById(hashId);
    if (!el) {
      closeDrawer(true);
      return;
    }
    var targetScroll = Math.round(scrollY + el.getBoundingClientRect().top);
    targetScroll = Math.max(0, targetScroll);

    body.style.top = '-' + targetScroll + 'px';
    window.scrollTo(0, targetScroll);
    closeDrawer(true);
    window.location.hash = hashId;
  }

  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var hashId = (a.hash || '').slice(1);
      var isServiceAnchor = SERVICE_ANCHOR_IDS.indexOf(hashId) !== -1 && isServicePage();
      if (isServiceAnchor) {
        e.preventDefault();
        window.__mjServiceAnchorFromDrawer = true;
        closeDrawerAndScrollToAnchor(hashId);
      } else {
        closeDrawer();
      }
    });
  });
}
